import { useEffect, useState } from "react";
import ICONS from "../../../../../assets/Icons";
import formatCurrency from "../../../../../utils/CurrencyFormater";
import DataActionField from "../../../../_utils/TransactionCommonComponents/DataActionField";

const BeneficiaryRecreateTxnStepAmountPaymentMethod = ({
  setIsNeft,
  setIsRtgs,
  txnPayLoad,
  setTxnPayLoad,
  beneTxnAccountData,
  isAmountAutoFilled,
  isMethodAutoFilled,
  setIsMethodAutoFilled,
  setCopyData,
  amountApplied,
}) => {
  const [isAmountCopied, setIsAmountCopied] = useState(false);
  const txn = beneTxnAccountData?.transaction?.[0];

  const copyToClipboard = (title, data_type, value) => {
    if (navigator?.clipboard?.writeText !== undefined) {
      navigator.clipboard
        .writeText(value?.toString())
        .then(() => {
          setCopyData({ title, data_type, value });
        })
        .catch((err) => {
          console.error("Clipboard copy failed:", err);
        });
    }
  };

  useEffect(() => {
    if (Number(txn?.amount) === Number(txnPayLoad?.amount)) {
      setIsAmountCopied(true);
    } else {
      setIsAmountCopied(false);
    }
  }, [txn?.amount, txnPayLoad?.amount]);
  return (
    <>
      <div className="w-full flex flex-col Qmd:flex-row gap-gap-xl mt-[70px] Qmd:mt-margin-md mb-margin-md px-padding-md Qlg:px-padding-base">
        <DataActionField
          label="Transfer Amount"
          value={`INR ${formatCurrency(Number(txn?.amount))}`}
          icon={
            isAmountCopied || Number(txn?.amount) === Number(txnPayLoad?.amount)
              ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
              : ICONS?.COPY
          }
          onClick={() => {
            const amount = Number(txn?.amount);

            copyToClipboard("Transfer Amount", "numeric", amount);
            setIsAmountCopied(true);
          }}
          hoverEnabled={isAmountCopied === false}
        />

        <DataActionField
          label="Select Payment Method"
          value={txn?.payment_method}
          icon={
            txnPayLoad?.settleType.toUpperCase() ===
            beneTxnAccountData?.transaction?.[0]?.payment_method
              ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
              : ICONS?.AUTOFILL_WHITE
          }
          onClick={() => {
            const method = txn?.payment_method;
            if (txnPayLoad?.settleType?.toUpperCase() === method) return;
            setIsMethodAutoFilled(true);
            setIsNeft(method === "NEFT");
            setIsRtgs(method === "RTGS");
            setTxnPayLoad((prev) => ({
              ...prev,
              settleType: method?.toLowerCase(),
            }));
          }}
          hoverEnabled={
            txnPayLoad?.settleType.toUpperCase() !==
            beneTxnAccountData?.transaction?.[0]?.payment_method
          }
        />
      </div>
    </>
  );
};

export default BeneficiaryRecreateTxnStepAmountPaymentMethod;
